<template>
    <div class="flex w-full py-4">
        <div class="flex m-auto">
            <div class="wrapper-state">
                <div class="flex flex-1">
                    <div class="state m-auto text-white bg-a-brown-502314 border border-a-brown-502314 flex">
                        <div class="text-14 m-auto">1</div>
                    </div>
                </div>
                <div class="text-a-brown-502314 text-center text-12 pt-1 lg:text-14">Your Order</div>
            </div>
            <div class="line-custom border-b border-a-brown-502314 border-dashed"></div>
            <div class="wrapper-state">
                <div class="flex flex-1">
                    <div class="state m-auto border flex"
                        :class="{'bg-a-brown-502314 text-white border-a-brown-502314': isPayment,
                                'bg-white text-a-brown-9f8273 border-a-brown-9f8273': !isPayment
                        }">
                        <div class="text-14 m-auto">2</div>
                    </div>
                </div>
                <div class="text-center text-12 pt-1 lg:text-14"
                    :class="{'text-a-brown-502314': isPayment,
                            'text-a-brown-9f8273': !isPayment}"    
                >Payment</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "CartStatus",
    props: {
        isPayment : { type: Boolean, default: null },
    },
}
</script>

<style lang="scss" scoped>
    .wrapper-state {
        width: 80px;
        .state {
            width: 24px;
            height: 24px;
            text-align: center;
            border-radius: 100%;
        }
    }
    .line-custom {
        width: 100px;
        height: 13px;
        margin: 0 -22px;
    }
</style>